import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseNabidkySmlouvySearch } from '@/lib/list-search';

const VykupList = lazy(() =>
  import('@/modules/ojeta-vozidla/VykupList').then((m) => ({ default: m.VykupList })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/vykup',
  component: () => (
    <Suspense fallback={null}>
      <VykupList />
    </Suspense>
  ),
  validateSearch: parseNabidkySmlouvySearch,
});
